// @ts-nocheck eb4d57c7
import { overridable } from '@wix/santa-editor-utils';
import _ from 'lodash';

const getAppStore = overridable((state, appDefinitionId) =>
  appDefinitionId ? _.get(state.appsStore, appDefinitionId) : null,
);

export { getAppStore };
